<template>
  <div class="auth-container">
    <!-- Left Side - Form -->
    <div class="auth-form-section">
      <h2 class="auth-title">Registrate gratis</h2>
      <p class="auth-subtitle">Empieza con notificaciones personalizadas.</p>
      
      <div v-if="registrationSuccess" class="alert alert-success">
        ¡Registro exitoso! Por favor, revisa tu correo electrónico para confirmar tu cuenta.
      </div>
      
      <form @submit.prevent="submit" class="auth-form">
        <input type="text" name="full_name" v-model="user.full_name" class="form-control" placeholder="Nombre" />
        <input type="email" name="email" v-model="user.email" class="form-control" placeholder="Correo electronico" />
        <input type="password" name="password" v-model="user.password" class="form-control" placeholder="Crea tu contraseña" />
        <input type="password" v-model="confirmPassword" class="form-control" placeholder="Confirma tu contraseña" />
        
        <button type="submit" class="auth-button auth-button-primary">Registrate</button>
        
        <div class="auth-divider">o registrate con</div>
        
        <div class="d-flex justify-content-between">
          <button type="button" class="auth-button-social auth-button-google">Google</button>
          <button type="button" class="auth-button-social auth-button-facebook">Facebook</button>
        </div>
          <p class="text-center mt-3">
          ¿Ya tienes una cuenta? 
          <router-link to="/login">Inicia Sesión</router-link>
        </p>
      </form>
    </div>
    
    <!-- Right Side - Information -->
    <div class="auth-info-section">
      <h2 class="auth-title">Mantente informado!</h2>
      <p class="auth-subtitle">Personaliza tus notificaciones.</p>
      
      <img src="@/assets/images/email-icon.svg" alt="Notificiaciones via Email" class="auth-image" />
      
      <p>Recibe notificaciones cuando quieras.</p>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';

export default defineComponent({
  name: 'RegisterView',
  data() {
    return {
      user: {
        email: '',
        full_name: '',
        password: '',
      },
      confirmPassword: '',
      registrationSuccess: false,
    };
  },
  methods: {
    ...mapActions(['register']),
    async submit() {
      if (this.user.password !== this.confirmPassword) {
        // Show password mismatch error
        console.error('Contraseñas no coinciden');
        return;
      }
      
      try {
        let result = await this.register(this.user);
        this.registrationSuccess = result;
      } catch (error) {
        console.log(error);
      }
    },
  },
});
</script>
